import { render, staticRenderFns } from "./PrintSgf.vue?vue&type=template&id=2f1914d2&scoped=true&"
import script from "./PrintSgf.vue?vue&type=script&lang=js&"
export * from "./PrintSgf.vue?vue&type=script&lang=js&"
import style0 from "./PrintSgf.vue?vue&type=style&index=0&id=2f1914d2&scoped=true&lang=scss&"
import style1 from "./PrintSgf.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1914d2",
  null
  
)

export default component.exports